import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("C:/vnimpex/tcms-framework-test-3001/layouts/default.vue").then(m => m.default || m)),
  fullpage: defineAsyncComponent(() => import("C:/vnimpex/tcms-framework-test-3001/layouts/fullpage.vue").then(m => m.default || m))
}